export type OrderDataRefreshActionType = "create" | "update" | "cancel";

export function shouldRefreshDataAfterOrderAction(actionType: OrderDataRefreshActionType) {
  return actionType === "create" || actionType === "cancel";
}
